export const formatDescription = (value: string): string => {
  let description = value;

  switch (description.toUpperCase()) {
    case 'AV':
      description = 'Alerta de Validade';
      break;

    case 'RG':
      description = 'Reabastecimento de Gôndola';
      break;

    case 'APV':
      description = 'Alerta de Perda de Venda';
      break;

    case 'AG':
      description = 'Auditoria de Gôndola';
      break;

    case 'CM':
      description = 'Consulta de Mercadoria';
      break;

    case 'CP':
      description = 'Consulta de Preço';
      break;

    case 'EM':
      description = 'Entrada de Mercadoria';
      break;

    case 'FRCC':
      description = 'FR Cencommerce';
      break;

    case 'FRC':
      description = 'FR Cornershop';
      break;

    case 'JAV':
      description = 'JOB Alerta Validade';
      break;

    case 'ADP':
      description = 'Auditoria de Preço';
      break;

    case 'ET':
      description = 'Emissão de Etiqueta';
      break;

    case 'EE':
      description = 'Emissão de Etiqueta';
      break;

    case 'AE':
      description = 'Ajuste de Estoque';
      break;

    default:
      break;
  }

  return description;
};
